module.exports = __webpack_public_path__ + "img/157e7f7.jpg";